export enum THEME_STRATEGY {
	GENERIC = 'generic',
	LOCAL = 'local',
	BRAND = 'brand',
	CUSTOM = 'custom',
}
